<template>
  <section 
    class="cover cover--condensed"
    data-type="cover"
    id="cover"
    style="height: 904.812px"
  >
    <div class="cover__content">
      <div class="cover__page-header">
        <div class="running-header__top-border"></div>
        <div class="running-header__text">
          <div>
            {{ 
              productBrand === 'Mitrex' 
                ? 'Energy Generating Materials'
                : 'Revolution in Smart Cladding' 
            }} 
          </div>
        </div>
      </div>
      <div class="cover__image__container">
        <img
          class="cover__image"
          v-if="projectInfo.cover_photo.value.url"
          :alt="projectInfo.cover_photo.value.name"
          :src="projectInfo.cover_photo.value.url">
        <div class="cover__image-placeholder" v-else>
        </div>
      </div>
      <div class="cover__info">
        <div class="info__left">
          <ul>
            <li>
              <div class="title is-4">
                {{ productBrand }} Condensed Budget Proposal
              </div>
              <div class="details">
                <div>
                  <div class="header">Project Address:</div>
                  <div>{{ projectInfo.address.value }}</div>
                </div>
                <div 
                  class="mt-1" 
                  v-for="[label, info] in contact"
                  :key="label"
                >
                  <template v-if="!['phone', 'quote no.'].includes(label.toLowerCase())">
                    <div class="header">{{ label }}</div>
                    <div>{{ info }}</div>
                  </template>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="info__right">
          <div 
            class="mb-1" 
            v-for="[label, info] in salesPerson"
            :key="label"
          >
            <div class="header">{{ label }}</div>
            <div>{{ info }}</div>
          </div>
          <div class="mb-1">
            <div class="header">Date</div>
            <div>
              {{ formatDate(projectInfo.date.value) }}
            </div>
          </div>
          <div>
            <div class="header">Version</div>
            <div>
              {{ projectInfo.contact.value['Quote No.'] }}
            </div>
          </div>
          <img 
            class="cover__logo" 
            src="../../assets/mitrex_and_cladify_logo.png"
          >
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { format } from 'date-fns'

export default {
  props: {
    projectInfo: {
      type: Object,
      required: true
    },
    productBrand: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      formatDate: (date) => {
        return date ? format(date, "MMM dd, yyyy") : null;
      }
    }
  },
  computed: {
    contact({ projectInfo }) {
      return Object.entries(projectInfo.contact.value)
        .filter(c => !['phone', 'quote no.'].includes(c[0].toLowerCase()))
        .map(c => c[0] === 'To' ? ['client', c[1]] : c)
    },
    salesPerson({ projectInfo }) {
      return Object.entries(projectInfo.sales_person.value)
        .filter(c => !['mobile', 'estimator'].includes(c[0].toLowerCase()))
        .map(c => {
          if (c[0] === 'From') {
            return ['Presented By', c[1]]
          } else if (c[0] === 'Phone') {
            return ['Phone Number', c[1]]
          } else {
            return c
          }
        })
    }
  }
}
</script>

<style scoped>
@import '../../styles/cover-page-condensed.css';
</style>
